var Roles = {
  CLIENT: 0,
  ADMIN: 1,
  SALES_REP: 2,
  SUPER_ADMIN: 3,
  SUPERVISOR: 4,
};

module.exports = Roles;
